const groupArrayItemsById = (array, key) => {
  const result = {};

  if (!array) {
    return result;
  }

  array?.forEach((item) => { result[item[key] || item?.id] = { ...item }; });

  return result;
};

export default groupArrayItemsById;
